// gtmAddToCart.js
// Minimal, single-item GA4 add_to_cart push

/**
 * Push a GA4 add_to_cart event for ONE item.
 * @param {Object} params
 * @param {string} params.item_name  - e.g., part name
 * @param {string|number} params.item_id - e.g., part id
 * @param {number|string} params.price   - e.g., part price
 * @param {number|string} params.quantity - item quantity
 */
export function pushAddToCart({ item_name, item_id, price, quantity }) {
  if (typeof window === "undefined") return; // SSR safety

  // Ensure dataLayer exists
  window.dataLayer = window.dataLayer || [];

  // Clear stale ecommerce object (GA4 best practice)
  window.dataLayer.push({ ecommerce: null });

  // Coerce number fields defensively
  const priceNum = Number(price);
  const qtyNum = Number(quantity || 1);

  window.dataLayer.push({
    event: "add_to_cart",
    ecommerce: {
      items: [
        {
          item_name: String(item_name),
          item_id: String(item_id),
          price: priceNum,
          quantity: qtyNum
        }
      ]
    }
  });
}
